var apiDataConstants = {
    boardCertificationCodes: {
        aba: 'ABA_ID',
        aoba: 'AOBA_ID',
        getId: function(name) {
            if (name === 'ABA') return this.aba;
            if (name === 'AOBA') return this.aoba;
        }
    },
    contactTracking: {
        mrm: 'MRM',
        callTypeCode: 'WEB',
        callTopicCode: 'MBRSHP_APPL',
        callTopicSubcode: 'NEW_INST_NEEDED'
    },
    programDegreeCodes: {
        notApplicable: 'Not Applicable'
    },
    programTypeCodes: {
        residency: '860510003',
        medSchool: '860510002',
        fellowship: '860510000',
        training: '860510004'
    },
    productTypes: {
        resident: 'RESIDENT',
        active: 'ACTIVE',
        affiliate: 'AFFILIATE',
        retired: 'RETIRED',
        educational: 'EDUCATIONAL',
        educationalStudent: 'EDUCATIONAL_STUDENT',
        medicalStudent: 'MEDICAL_STUDENT',
        anesAsst: 'ANESASST'
    }
    
};

module.exports = apiDataConstants;